import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getStockTakeList(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.INVENTORY.STOCK_TAKE_LIST, action.payload, true);
}
export function* deleteStockTake(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.STOCK_TAKE_DELETE, action.payload, true);
}
export function* searchStockTransfer(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.STOCK_TRANSFER_SEARCH, action.payload, true);
}
export function* deleteStockTransfer(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.STOCK_TRANSFER_DELETE, action.payload, true);
}

export function* searchSentToRepair(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.SENT_TO_REPAIR_SEARCH, action.payload, true);
}

export function* searchPendingRestock(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.PENDING_RESTOCK_SEARCH, action.payload, true);
}

export function* insertUpdatePendingRestock(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.PENDING_RESTOCK_INSERT_UPDATE, action.payload, true);
}

export function* searchVendors(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.VENDOR_SEARCH, action.payload, true);
}

export function* scheduleInsertUpdate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.SCHEDULE_INSERT_UPDATE, action.payload, true);
}

export function* getStockTakeDetails(action: any): any {
    // expects action.payload = { id }
    const url = APIS.INVENTORY.STOCK_TAKE_DETAILS + action.payload.id;
    yield call(sagaFunction, action, CallApi.GET, url, null, true);
}

export function* searchVendorStockReturn(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.VENDOR_STOCK_RETURN_SEARCH, action.payload, true);
}
export function* deleteVendorStockReturn(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.VENDOR_STOCK_RETURN_DELETE, action.payload, true);
}
export function* vendorStockReturnStatusChange(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.VENDOR_STOCK_RETURN_STATUS_CHANGE, action.payload, true);
}
export function* getVendorStockReturnDetails(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.GET,
        `${APIS.INVENTORY.VENDOR_STOCK_RETURN_DETAILS}/${action.payload}`,
        null,
        true
    );
}
export function* insertUpdateVendorStockReturn(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.INVENTORY.VENDOR_STOCK_RETURN_INSERT_UPDATE,
        action.payload,
        true
    );
}

export function* insertUpdateStockTransferWithinLocationTransfer(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.INVENTORY.INSERT_UPDATE_STOCK_TRANSFER_WITHIN_LOCATION_TRANSFER,
        action.payload,
        true
    );
}

export function* getStockTransferDetails(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.GET,
        `${APIS.INVENTORY.STOCK_TRANSFER_DETAILS}/${action.payload}`,
        null,
        true
    );
}

export function* getPreferredVendors(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.PREFERRED_VENDORS, action.payload, true);
}

export function* autoPOUnassignedProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.AUTO_PO_UNASSIGNED_PRODUCTS, action.payload, true);
}

export function* autoPOVendorProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.AUTO_PO_VENDOR_PRODUCTS, action.payload, true);
}

export function* manualPOUnassignedProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.MANUAL_PO_UNASSIGNED_PRODUCTS, action.payload, true);
}

export function* manualPOVendorProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.MANUAL_PO_VENDOR_PRODUCTS, action.payload, true);
}

export function* insertUpdatePO(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.INSERT_UPDATE_PO, action.payload, true);
}

export function* changeVendor(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.CHANGE_VENDOR, action.payload, true);
}

export function* getInboundOrderQty(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.INBOUND_ORDER_QTY, action.payload, true);
}

// export function* getPurchaseOrderDetails(action: any): any {
//     // expects action.payload = { id }
//     const url = `${APIS.INVENTORY.PURCHASE_ORDER_DETAILS}${action.payload.id}`;
//     yield call(sagaFunction, action, CallApi.GET, url, null, true);
// }

export function* searchPurchaseOrder(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.PURCHASE_ORDER_SEARCH, action.payload, true);
}

export function* purchaseOrderDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.INVENTORY.PURCHASE_ORDER_DETAILS + action.payload.id, {}, true);
}

export function* deletePurchaseOrder(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.PURCHASE_ORDER_DELETE, action.payload, true);
}

export function* receiveOrderSearch(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.RECEIVE_ORDER_SEARCH, action.payload, true);
}

export function* vendorStockReturnReceiveOrderSearch(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.VENDOR_STOCK_RETURN_RECEIVE_ORDER_SEARCH, action.payload, true);
}

export function* vendorStockReturnReceiveOrderInsertUpdate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.VENDOR_STOCK_RETURN_RECEIVE_ORDER_INSERT_UPDATE, action.payload, true);
}

export function* vendorStockReturnReceiveOrderDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.INVENTORY.VENDOR_STOCK_RETURN_RECEIVE_ORDER_DETAILS + action.payload.id, {}, true);
}

export function* vendorStockReturnReceiveOrderDelete(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.VENDOR_STOCK_RETURN_RECEIVE_ORDER_DELETE, action.payload, true);
}

export function* receiveOrderInsertUpdate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.RECEIVE_ORDER_INSERT_UPDATE, action.payload, true);
}

export function* receiveOrderDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.INVENTORY.RECEIVE_ORDER_DETAILS + action.payload.id, {}, true);
}

export function* deleteReceiveOrder(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.RECEIVE_ORDER_DELETE, action.payload, true);
}

export function* sendEmailToVendor(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.SEND_EMAIL_TO_VENDOR, action.payload, true);
}

export function* getStockCountDetails(action: any): any {
    // expects action.payload = { id }
    const url = APIS.INVENTORY.STOCK_COUNT_DETAILS + action.payload.id;
    yield call(sagaFunction, action, CallApi.GET, url, null, true);
}

export function* startStockCount(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.START_STOCK_COUNT, action.payload, true);
}

export function* completeStockCount(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.COMPLETE_STOCK_COUNT, action.payload, true);
}

export function* changeStockCountStatus(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.CHANGE_STOCK_COUNT_STATUS, action.payload, true);
}

export function* insertProduct(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.INSERT_PRODUCT, action.payload, true);
}

export function* purchaseOrderStatusChange(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.INVENTORY.PURCHASE_ORDER_STATUS_CHANGE, action.payload, true);
}

export function* getStoreCredit(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.SETTINGS.STORE_CREDIT_GET, action.payload, true);
}

export function* insertUpdateStoreCredit(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.SETTINGS.STORE_CREDIT_INSERT_UPDATE, action.payload, true);
}

export function* receiveStockTransfer(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        `${APIS.INVENTORY.RECEIVE_STOCK_TRANSFER}/${action.payload.stockTransferId}`,
        action.payload,
        true
    );
}

export function* getProductInventoryInsight(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.INVENTORY.PRODUCT_INVENTORY_INSIGHT, action.payload, true);
}
